import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useTranslation } from 'react-i18next';
import { BUSINESS_ROUTE } from 'data/global';

export default function useUnauthorized(condition: boolean) {
  const [isAuthorizing, setIsAuthorizing] = useState(true);

  const { popError } = useContext(PopNotificationsContext);

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    if (!condition) {
      popError(t('unauthorizedForAction'));
      navigate(BUSINESS_ROUTE, { replace: true });
    } else {
      setIsAuthorizing(false);
    }
  }, [condition, navigate, popError, t]);

  return { isAuthorizing };
}
